import React from "react";
import { Users } from "@phosphor-icons/react";

/**
 * Small avatar group showing other users currently working on the same resource.
 * Renders nothing if there are no others.
 */
const COLORS = [
  "#325E7D", "#10B981", "#F59E0B", "#8B5CF6", "#EF4444",
  "#06B6D4", "#EC4899", "#84CC16", "#F97316", "#14B8A6",
];

function initialsOf(name = "", email = "") {
  const src = name?.trim() || email || "";
  if (!src) return "?";
  const parts = src.split(/[\s@.]+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

function colorFor(seed) {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) hash = (hash * 31 + seed.charCodeAt(i)) % 9999;
  return COLORS[hash % COLORS.length];
}

export default function PresenceBar({ others = [], lang = "de" }) {
  if (!others || others.length === 0) return null;
  // de-duplicate by user_id (in case multiple item-locks per user)
  const map = new Map();
  others.forEach((o) => { if (o.user_id && !map.has(o.user_id)) map.set(o.user_id, o); });
  const list = Array.from(map.values());
  const visible = list.slice(0, 4);
  const overflow = list.length - visible.length;

  return (
    <div className="inline-flex items-center gap-2" data-testid="presence-bar">
      <Users size={14} className="text-[var(--muted)]" />
      <span className="text-xs text-[var(--muted)] hidden sm:inline">
        {lang === "de" ? "Aktiv:" : "Active:"}
      </span>
      <div className="flex -space-x-2">
        {visible.map((u) => {
          const ini = initialsOf(u.user_name, u.user_email);
          const color = colorFor(u.user_id || u.user_email || ini);
          return (
            <div
              key={u.user_id}
              title={`${u.user_name || u.user_email}${u.item_id ? ` · ${u.resource}` : ""}`}
              data-testid={`presence-${u.user_email}`}
              className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-semibold text-white border-2 border-[var(--surface)] shadow-sm"
              style={{ backgroundColor: color }}
            >
              {ini}
            </div>
          );
        })}
        {overflow > 0 && (
          <div className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-semibold border-2 border-[var(--surface)] bg-[var(--row-hover)] text-[var(--muted)]">
            +{overflow}
          </div>
        )}
      </div>
    </div>
  );
}
